'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EventPage;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDocumentMeta = require('react-document-meta');

var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _caligramReact = require('caligram-react');

var _event = require('caligram-react/dist/helpers/event');

var _containers = require('../containers');

var _config = require('../config.js');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function EventPage(_ref) {
  var event = _ref.event,
      location = _ref.location,
      push = _ref.push;

  var actions = {
    backButtonAction: function backButtonAction() {
      return push({ pathname: '/' });
    },
    audienceAction: function audienceAction(audience) {
      return push({ pathname: '/evenements', query: { audiences: audience.id } });
    },
    typeAction: function typeAction(type) {
      return push({ pathname: '/evenements', query: { types: type.id } });
    },
    tagAction: function tagAction(tag) {
      return push({ pathname: '/evenements', query: { tags: tag.id } });
    },
    groupAction: function groupAction(group) {
      return push({ pathname: '/evenements', query: { organizations: group.id } });
    }
  };

  var title = event.title,
      types = event.types,
      description = event.description,
      ticket_url = event.ticket_url,
      facebook_url = event.facebook_url,
      photo_url = event.photo_url,
      dates = event.dates,
      slug = event.slug,
      id = event.id,
      venue = event.venue,
      room = event.room,
      price_type = event.price_type,
      price_notes = event.price_notes,
      prices = event.prices,
      tags = event.tags,
      groups = event.groups,
      contact_name = event.contact_name,
      contact_email = event.contact_email,
      contact_phone = event.contact_phone,
      contact_url = event.contact_url,
      video_url = event.video_url;


  var contactProps = {
    name: contact_name,
    email: contact_email,
    phone: contact_phone,
    url: contact_url
  };

  var selectedDate = dates.find(function (date) {
    return (0, _moment2.default)(date.start_date).format('YYYY-MM-DD_HH-mm-ss') === location.query.date;
  });

  var urlVideoFinal = video_url;
  if (video_url && video_url.includes('vimeo') && !video_url.includes('player')) {
    var video_id = video_url.split('/').pop();
    urlVideoFinal = 'https://player.vimeo.com/video/' + video_id;
  } else if (video_url && !video_url.includes('vimeo') && !video_url.includes('embed')) {
    var _video_id = video_url.includes('watch') ? video_url.split('=').pop() : video_url.split('/').pop();
    urlVideoFinal = 'https://www.youtube.com/embed/' + _video_id;
  }

  return _react2.default.createElement(
    'div',
    { className: 'EventPage' },
    _react2.default.createElement(_caligramReact.EventMeta, { component: _reactDocumentMeta2.default, event: event, siteName: _config2.default.app.title, twitterUsername: _config2.default.app.meta.property['twitter:creator'] }),
    _react2.default.createElement(
      _caligramReact.Page,
      { className: 'event', layout: 'custom' },
      _react2.default.createElement(
        'div',
        { className: 'description' },
        _react2.default.createElement(_caligramReact.SelectionList, { available: types, appearance: 'tag', labelKey: 'name', layout: 'inline', action: actions.typeAction }),
        _react2.default.createElement(
          'h1',
          null,
          title
        ),
        _react2.default.createElement(_caligramReact.EventDescription, { description: description }),
        ticket_url && _react2.default.createElement(_caligramReact.Button, { className: 'ticket', href: ticket_url, title: 'Billetterie', type: 'primary', iconRight: 'chevronRight', newWindow: true }),
        facebook_url && _react2.default.createElement(_caligramReact.Button, { className: 'ticket', href: facebook_url, title: '\xC9v\xE9nement facebook', type: 'primary', iconRight: 'chevronRight', newWindow: true }),
        video_url && _react2.default.createElement(
          'div',
          { className: 'videoContainer' },
          _react2.default.createElement('iframe', { className: 'video',
            src: urlVideoFinal,
            allow: 'autoplay; fullscreen; picture-in-picture',
            frameBorder: '0',
            allowFullScreen: true
          })
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'details' },
        _react2.default.createElement(_caligramReact.EventImage, { src: photo_url }),
        _react2.default.createElement(
          _caligramReact.HeadingBlock,
          { title: 'Date / heure', icon: 'clock' },
          _react2.default.createElement(_caligramReact.EventDate, { dates: dates, selectedDate: selectedDate, pathName: '/evenements/' + slug + '/' + id })
        ),
        _react2.default.createElement(
          _caligramReact.HeadingBlock,
          { title: 'Lieu', icon: 'pin' },
          _react2.default.createElement(_caligramReact.EventVenue, { venue: venue, room: room }),
          _react2.default.createElement(_caligramReact.StaticMap, { latitude: venue.latitude, longitude: venue.longitude, apiKey: _config2.default.app.googleMaps.apiKey, width: 180, height: 120 })
        ),
        (0, _event.hasPrice)(event) && _react2.default.createElement(
          _caligramReact.HeadingBlock,
          { title: 'Prix', icon: 'dollarSign' },
          _react2.default.createElement(_caligramReact.EventPrice, { type: price_type, notes: price_notes, prices: prices })
        ),
        (0, _event.hasContact)(event) && _react2.default.createElement(
          _caligramReact.HeadingBlock,
          { title: 'Renseignements', icon: 'person' },
          _react2.default.createElement(_caligramReact.EventContact, contactProps)
        ),
        ticket_url && _react2.default.createElement(_caligramReact.Button, { className: 'ticket', href: ticket_url, title: 'Visiter le site web', type: 'primary', iconRight: 'chevronRight', newWindow: true })
      ),
      _react2.default.createElement(
        'div',
        { className: 'extras' },
        _react2.default.createElement(
          'div',
          { className: 'tools' },
          _react2.default.createElement(
            _caligramReact.HeadingBlock,
            { title: 'Partager', className: 'share' },
            _react2.default.createElement(_caligramReact.ShareLinks, { event: event, icons: ['facebook', 'twitter', 'linkedIn'], noTint: true })
          ),
          _react2.default.createElement(
            _caligramReact.HeadingBlock,
            { title: 'Sauvegarder', className: 'save' },
            _react2.default.createElement(_caligramReact.ShareLinks, { event: event, icons: ['google', 'yahoo', 'ical', 'print'] })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'secondary' },
          tags.length > 0 && _react2.default.createElement(
            _caligramReact.HeadingBlock,
            { title: 'Mots-cl\xE9s', className: 'tags' },
            _react2.default.createElement(_caligramReact.SelectionList, { available: tags, appearance: 'plain', labelKey: 'name', action: actions.tagAction })
          ),
          groups.length > 0 && _react2.default.createElement(
            _caligramReact.HeadingBlock,
            { title: 'Groupes', className: 'groups' },
            _react2.default.createElement(_caligramReact.SelectionList, { available: groups, appearance: 'plain', labelKey: 'name', action: actions.groupAction })
          )
        )
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'filters' },
      _react2.default.createElement(_containers.FiltersContainer, null)
    )
  );
} /* eslint-disable camelcase */


EventPage.propTypes = {
  event: _react.PropTypes.object.isRequired,
  location: _react.PropTypes.any,
  params: _react.PropTypes.object.isRequired
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/EventPage.js
// module id = 1108
// module chunks = 0